import './style.modules.css';
import logo from '../../assets/img/Sobr.png';
import iphone from '../../assets/img/iphone.png';
import match from '../../assets/img/match.png';
import chat from '../../assets/img/chat.png';
import like from '../../assets/img/like.png';
import map from '../../assets/img/mapa.png';
import midias from '../../assets/img/Social Media.svg';
import vector from '../../assets/img/Vector.png';
import vector2 from '../../assets/img/Vector2.png';
import vector3 from '../../assets/img/Vector3.png';
import vector4 from '../../assets/img/Vector4.png';
import vector5 from '../../assets/img/Vector5.png';
import vector6 from '../../assets/img/Vector6.png';
import google from '../../assets/img/boton google play.svg';
import apple from '../../assets/img/boton app store.svg';
import ny from '../../assets/img/nyc.svg';
import arrow from '../../assets/img/arrow.svg';
import Navbar from '../../components/navbar';

function App() {

    // Função para rolar até o menu principal
    const scrollToMenu = () => {
        const menuElement = document.querySelector('.logo');
        if (menuElement) {
            menuElement.scrollIntoView({ behavior: 'smooth' });
        }
    };


    return (
        <>
            <Navbar />
            <div className="logo">
                <img src={logo} height="36" width="78" alt="logo" title="logo" />
            </div>
            <body>
                <div className="iphone2" style={{ backgroundImage: `url(${vector})` }}>
                    <img src={iphone} alt="iphone" title="iphone" height="350" />
                </div>
                <main>
                    <section className="hero">
                        <div className="content">
                            <h1>Conecte-se com pessoas que estão revolucionando a felicidade!</h1>
                            <p>Sobr é mais do que um aplicativo - é um ponto de encontro para aqueles que escolheram um estilo de vida sóbrio, repleto de saúde e diversão.
                            </p>
                        </div>
                        <button>CLIQUE AQUI</button>
                    </section>
                </main>
                <div className='buttons'>
                    <img className="appstore" src={apple} alt="App store" title="App store" height="38" width="140" />
                    <img className="google" src={google} alt="Google play" title="Google play" height="38" width="140" />
                </div>
                <div className="match" style={{ backgroundImage: `url(${vector2})` }}>
                    <img src={match} alt="match" title="match" height="480" />
                </div>
                <div className="content2">
                    <h1>Conexões autênticas</h1>
                    <p>Nosso algoritmo de matchmaking personalizado vai além do superficial. Analisamos seus interesses, preferências e comportamentos para sugerir perfis verdadeiramente compatíveis. Faça conexões significativas com pessoas que compartilham seus valores e estão comprometidas com a sobriedade.
                    </p>                    
                </div>                
                <div className="chat" style={{ backgroundImage: `url(${vector3})` }}>
                    <img src={chat} height="480" alt="chat" title="chat" />
                </div>
                <div className="content3">
                    <h1>Converse com seus matches</h1>
                    <p>Aqui, a comunicação é segura e privada. Use nosso recurso de bate-papo para se conectar com seus matches em tempo real. Compartilhe mensagens, fotos e momentos especiais, construindo laços genuínos e duradouros.
                    </p>
                </div>
                <div className="like" style={{ backgroundImage: `url(${vector4})` }}>
                    <img src={like} height="450" alt="like" title="like" />
                </div>
                <div className="content4">
                    <h1>Mostre sua verdadeira essência</h1>
                    <p>Seja você mesmo! Crie um perfil autêntico que reflita sua personalidade e interesses. Atraia matches ideais com base na sua autenticidade e compatibilidade, abrindo as portas para conexões reais e significativas.
                    </p>
                </div>
                <div className="container">
                    <img className="shadem" src={vector5} alt="shade" title="shade" />
                    <img className="nycm" src={ny} alt="NYC" />
                    <img className="mapm" src={map} alt="map" title="map" height="500" />
                </div>
                <div className="content5">
                    <h1>Descubra novos lugares</h1>
                    <p>Explore o melhor da vida sóbria com o Sobr Places. Descubra eventos, atividades e locais perfeitos para socializar e conhecer novas pessoas em sua comunidade. Viva experiências autênticas e fortaleça seus laços na jornada para uma vida mais feliz e saudável.
Junte-se a nós na Sobr e descubra um mundo de possibilidades, onde a sobriedade é sinônimo de liberdade, alegria e conexão genuína.
                    </p>
                </div>
                {/* <div className="content6">
                    <h1>Sobr shouldn’t be somber.</h1>
                    <p>We created Sobr with the belief that being sober isn’t the end of the good times, but the start. Here’s our story in a few more words…</p>
                </div>
                <div className="support-card">
                    <div className="peaple">
                        <img src={peaple} alt="members" title="members" />
                    </div>
                    <div className="text">
                        <h2>+190.000</h2>
                        <p>members</p>
                    </div>
                </div>
                <div className="support-card">
                    <div className="icon">
                        <img src={icon} alt="support" title="support" />
                    </div>
                    <div className="text">
                        <h2>+3.3M</h2>
                        <p>Support Messages</p>
                    </div>
                </div>
                <div className="support-card">
                    <div className="emoji">
                        <img src={emoji} alt="friendships" title="friendships" />
                    </div>
                    <div className="text">
                        <h2>+155,000</h2>
                        <p>friendships</p>
                    </div>
                </div>
                <div className="content7">
                    <h1>What our happy customers are saying</h1>
                </div>
                <div className="review-box">
                    <div className="header">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starx">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="content">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verified">
                        <span>Verified by</span>
                    </div>
                </div> */}
                <div className="shade2" style={{ backgroundImage: `url(${vector6})` }}>
                </div>
                <div className="midias">
                    <img className="midias" src={midias} height="24" width="260" alt="mídias" title="mídias" />
                </div>
                <footer>
                    <div className="footer-content">
                        <p>Termos de Serviço | Política de Privacidade</p>
                    </div>
                    <div className="footer-copyright">
                    &copy; 2024 Sobr Inc., Todos os Direitos Reservados   
                    </div>
                    {/* Ícone da seta para rolar até o menu principal */}
                    <div onClick={scrollToMenu} style={{ cursor: 'pointer', marginTop: '20px' }}>
                        <img src={arrow} height="24" width="24" alt="scroll to top" title="scroll to top" />
                    </div>
                </footer>
            </body>
        </>
    );
}

export default App;
